import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UnlockFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { useCallback, useEffect, useState } from "react";
import { reactNl2Br } from "@devowl-wp/react-utils";
import { IN_APP_FOMO_URL_PARAMETER_TO_DEACTIVATE_WEBSITE_FOMO, UpsellInAppFomoCouponCounter } from "./inAppFomoCouponCounter.js";
import { UpsellModalHint } from "./modalHint.js";
import { useI18n } from "../../contexts/i18n.js";
import { useUpsell } from "../../contexts/upsell.js";
const UpsellModal = ({ mode = "pro", visible = false, showHints = true, showFomoCouponCounter = true, title, testDrive = false, assetName, assetMaxHeight, description, feature, onClose, inContainer, inContainerElement })=>{
    const { __, _i } = useI18n();
    const { proUrl, hint, isPro } = useUpsell();
    const [descriptionRef, setDescriptionRef] = useState();
    const handleRedirect = useCallback(()=>{
        if (mode === "pro") {
            window.open(`${proUrl}&feature=${feature}&${IN_APP_FOMO_URL_PARAMETER_TO_DEACTIVATE_WEBSITE_FOMO}`, "_blank").focus();
        } else {
            window.location.href = `#/licensing?navigateAfterActivation=${encodeURIComponent(window.location.href)}`;
        }
        onClose?.();
    }, [
        onClose,
        mode
    ]);
    // Do not automatically scroll / focus the container if `inContainer` is set
    useEffect(()=>{
        if (inContainer && descriptionRef) {
            descriptionRef.parentElement.parentElement.parentElement.removeAttribute("tabIndex");
        }
    }, [
        descriptionRef
    ]);
    // Do not output the model until the container is ready
    if (inContainer && !inContainerElement) {
        return null;
    }
    const assetSrc = assetName ? `https://assets.devowl.io/in-app/wp-real-cookie-banner/${assetName}` : undefined;
    return /*#__PURE__*/ _jsxs(Modal, {
        transitionName: inContainer ? null : undefined,
        open: inContainer ? true : visible,
        title: /*#__PURE__*/ _jsxs("span", {
            children: [
                /*#__PURE__*/ _jsx(UnlockFilled, {}),
                "\xa0",
                title,
                "\xa0",
                mode === "pro" && __("Get PRO!")
            ]
        }),
        onOk: handleRedirect,
        onCancel: onClose,
        cancelText: __("No, not interested..."),
        okText: mode === "pro" ? __("I want to learn more!") : isPro ? __("Activate license") : __("Activate free license"),
        className: "rcb-antd-hero-modal",
        width: assetName ? 800 : 700,
        getContainer: inContainer ? inContainerElement : undefined,
        children: [
            !!assetName && (assetName.endsWith(".webm") ? /*#__PURE__*/ _jsx("video", {
                autoPlay: true,
                muted: true,
                loop: true,
                style: {
                    marginTop: 10,
                    maxHeight: assetMaxHeight
                },
                children: /*#__PURE__*/ _jsx("source", {
                    src: assetSrc,
                    type: "video/webm"
                })
            }) : /*#__PURE__*/ _jsx("img", {
                style: {
                    marginTop: 10,
                    maxHeight: assetMaxHeight
                },
                src: assetSrc
            })),
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    maxWidth: 600,
                    margin: "auto"
                },
                ref: setDescriptionRef,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: typeof description === "string" ? reactNl2Br(description) : description
                    }),
                    testDrive && mode === "pro" && /*#__PURE__*/ _jsx("p", {
                        children: _i(__("Check out this feature with a {{a}}free sandbox{{/a}} before buying!"), {
                            a: /*#__PURE__*/ _jsx("a", {
                                href: __("https://try.devowl.io/?product=RCB"),
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        })
                    })
                ]
            }),
            !!hint && showHints && mode === "pro" && /*#__PURE__*/ _jsx("div", {
                style: {
                    maxWidth: 600,
                    margin: "auto",
                    textAlign: "left"
                },
                children: /*#__PURE__*/ _jsx(UpsellModalHint, {
                    ...hint
                })
            }),
            showFomoCouponCounter && mode === "pro" && /*#__PURE__*/ _jsx(UpsellInAppFomoCouponCounter, {
                style: {
                    marginBottom: 15
                }
            })
        ]
    });
};
export { UpsellModal };
